import { Directive, ElementRef, HostListener } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appTime]'
})
export class AppTimeDirective extends AppAbstractDirective {

  private backText: string;
  private historicText: string = '';

  constructor(private element: ElementRef) {
    super();
  }

  @HostListener('change', ['$event.target']) onChange(): void {
    if (this.element.nativeElement.type === 'text') {
      const timeValue: string = this.element.nativeElement.value;
      let error = false;
      let result = '';
      let hour = '';
      let min = '';
      const res = timeValue.split(':');
      if (res.length === 1) {
        if (timeValue.length === 4) {
          hour = timeValue.substring(0, 2);
          min = timeValue.substring(2, 4);
        } else if (timeValue.length === 3) {
          hour = '0' + timeValue.substring(0, 1);
          min = timeValue.substring(1, 3);
          if (Number(min) > 59) {
            hour = timeValue.substring(0, 2);
            min = '0' + timeValue.substring(2, 3);
          }
          result = hour + ':' + min;
        } else if (timeValue.length === 2) {
          hour = '0' + timeValue.substring(0, 1);
          min = '0' + timeValue.substring(1, 3);
        } else {
          error = true;
        }
      } else if (res.length === 2) {
        hour = res[0];
        min = res[1];
        if (hour.length === 1) {
          hour = '0' + hour;
        }
        if (min.length === 1) {
          min = '0' + min;
        }
      } else {
        error = true;
      }
      if (error) {
        result = '';
      } else {
        if (Number(hour) <= 12 && Number(min) <= 59) {
          result = hour + ':' + min;
        } else {
          result = '';
        }
      }
      this.element.nativeElement.value = result;
      this.element.nativeElement.type = 'time';
    }
  }


  @HostListener('focus', ['$event.target']) onFocus(): void {
    this.backText = '';
    this.historicText = this.element.nativeElement.value;
  }

  @HostListener('blur', ['$event']) onBlur(event: KeyboardEvent): void {
    if (this.element.nativeElement.value && this.element.nativeElement.value != '') {
      var lastTwo = this.element.nativeElement.value.substr(this.element.nativeElement.value.length - 2);
      if (lastTwo == '59' && !this.historicText.includes(lastTwo)) {
        this.element.nativeElement.value = '';
        this.element.nativeElement.focus();
        
      } else {
        var firstTwo = this.element.nativeElement.value.substr(0, 2);
        if (firstTwo == '23' && !this.historicText.includes(firstTwo)) {
          this.element.nativeElement.value = '';
          this.element.nativeElement.focus();
        }
      }
    }

    this.historicText = '';
  }

  @HostListener('keyup', ['$event']) onkeyup(event: KeyboardEvent): void {

    if (event.key >= '0' && event.key <= '9') {
      this.backText = this.backText + event.key;
      this.historicText = this.historicText + event.key;

      // console.log('--------------------------------');
      // console.log(this.element.nativeElement.value);
      // console.log(event.key);

      // if (this.element.nativeElement.value && this.element.nativeElement.value != '') {
      //   var lastTwo = this.element.nativeElement.value.substr(this.element.nativeElement.value.length - 2);
      //   if (lastTwo == '59' && !this.historicText.includes(lastTwo)) {
      //     this.element.nativeElement.value = '';
      //   } else {
      //     var firstTwo = this.element.nativeElement.value.substr(0, 2);
      //     if (firstTwo == '23' && !this.historicText.includes(firstTwo)) {
      //       this.element.nativeElement.value = '';
      //     }
      //   }
      // }
  
    } else if (event.code === 'NumpadDecimal') {
      if (this.element.nativeElement.type === 'time') {
        if (this.backText.length === 1) {
          this.backText = '0' + this.backText;
          this.backText = this.backText + ':';
          this.element.nativeElement.type = 'text';
          this.element.nativeElement.value = this.backText;
        }
      }
    }
  }

}
